var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoSecondsOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 102,
    viewBox: "0 0 374 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 101C1 101 48.671 96.4047 94 68.2711C139.329 40.1374 142.224 1 187 1C231.776 1 235.576 40.1374 280 68.2711C324.424 96.4047 373 101 373 101H1Z",
    fill: "url(#paint0_linear_1205_1224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 101L0.952024 100.502L1 101.5H373L373.047 100.502L373 101C373.047 100.502 373.047 100.502 373.047 100.502L373.045 100.502L373.039 100.501L373.014 100.499L372.91 100.489C372.818 100.479 372.681 100.465 372.499 100.445C372.135 100.404 371.594 100.342 370.889 100.252C369.48 100.072 367.415 99.7832 364.798 99.3491C359.562 98.4809 352.118 97.0304 343.286 94.7022C325.621 90.045 302.423 81.8797 280.268 67.8486C262.509 56.602 251.281 43.6068 241.267 32.0175C238.798 29.1601 236.403 26.3882 234.002 23.7489C227.94 17.0854 221.836 11.2667 214.418 7.11841C206.992 2.96511 198.273 0.5 187 0.5C175.726 0.5 167.064 2.96517 159.707 7.11942C152.36 11.2684 146.34 17.0879 140.336 23.7507C138.101 26.2301 135.868 28.8268 133.568 31.5016C123.49 43.2184 112.125 56.4333 93.7363 67.8462C71.126 81.8794 47.9256 90.0452 30.3734 94.7024C21.5985 97.0306 14.2384 98.4811 9.07396 99.3493C6.49183 99.7834 4.45882 100.072 3.07257 100.252C2.37945 100.342 1.84803 100.404 1.49054 100.445C1.31179 100.465 1.17652 100.479 1.08626 100.489L0.984814 100.499L0.959766 100.502L0.953723 100.502L0.952329 100.502C0.952086 100.502 0.952024 100.502 1 101Z",
    stroke: "#CCCFD4",
    strokeOpacity: 0.495556,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 100.999C142 77.0547 142 36.5071 142 23.1306C153.693 10.3187 165.561 1 187.394 1C209.154 1 221.23 10.2558 233 23.0006C233 40.8116 233 81.5601 233 100.999C200.262 100.999 169.423 100.999 142 100.999Z",
    fill: "#FFB15D",
    fillOpacity: 0.252406
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1205_1224",
    x1: 310.749,
    y1: 29.0032,
    x2: 64.0711,
    y2: 29.0032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE0F6",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507609,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AE0F6",
    stopOpacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSecondsOutline);
export default __webpack_public_path__ + "static/media/TwoSecondsOutline.afeb05f6ea299f3204647716a09836c8.svg";
export { ForwardRef as ReactComponent };